import { TableContainer } from 'ui/StyledComponents/Tables'
import { useIntl } from 'react-intl'
import {
	TableRow,
	TableColumn,
	DataTable,
	TableHeader,
	TableBody,
} from 'react-md'
import { accountingSettingHeaders, accountingSettingRows } from './constants'
import LoadingState from 'ui/components/LoadingState'
import { LoadingContainer } from '../../components'
import AccountingSettingRow from './AccountingSettingRow'
import type { AccountingSetting } from './types'

type AccountingSettingsTableProps = {
	accountingSetting: AccountingSetting
	loading: boolean
}

const AccountingSettingsTable = ({
	accountingSetting,
	loading,
}: AccountingSettingsTableProps) => {
	const intl = useIntl()

	const renderTableHeaders = () => {
		return (
			<TableRow style={{ border: 'none' }}>
				{accountingSettingHeaders
					.filter((h) => h.show)
					.map((header) => (
						<TableColumn key={String(header.key)}>
							<p className="text-strong text-subtle">{header.title(intl)}</p>
						</TableColumn>
					))}
				<TableColumn key={'children-header'}></TableColumn>
			</TableRow>
		)
	}

	return (
		<TableContainer>
			{loading && (
				<LoadingContainer>
					<LoadingState />
				</LoadingContainer>
			)}
			{accountingSetting ? (
				<DataTable
					plain
					tableStyle={{ border: 'none', borderCollapse: 'collapse' }}
					style={{
						maxHeight: 'calc(100vh - 205px)',
						border: 'none',
					}}
				>
					<TableHeader
						style={{
							position: 'sticky',
							top: 0,
							zIndex: 1,
						}}
					>
						{renderTableHeaders()}
					</TableHeader>
					<TableBody>
						{accountingSettingRows.map((settingRow) => (
							<AccountingSettingRow
								key={String(settingRow.key)}
								accountingSetting={accountingSetting}
								settingRow={settingRow}
							/>
						))}
					</TableBody>
				</DataTable>
			) : null}
		</TableContainer>
	)
}

export default AccountingSettingsTable
